<template>
  <div :class="shellClass">
    <div :class="bodyClass">
      <div :class="contentClass">
        <div class="filter-bar-row">
          <slot />
        </div>

        <div v-if="$slots.actions" class="filter-bar-actions">
          <slot name="actions" />
        </div>
      </div>

      <div
        v-if="showRefresh || $slots.searchActions"
        class="mt-4 flex flex-wrap items-center justify-end gap-2"
      >
        <button
          v-if="showRefresh"
          type="button"
          class="btn-secondary inline-flex items-center gap-2"
          :disabled="refreshDisabled || refreshLoading"
          @click="handleRefresh"
        >
          <svg
            class="h-4 w-4"
            :class="{ 'animate-spin': refreshLoading }"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
            />
          </svg>
          <span>{{ refreshText }}</span>
        </button>

        <slot name="searchActions" />
      </div>

      <div v-if="$slots.extra" class="mt-4">
        <slot name="extra" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  shellClass: {
    type: String,
    default: 'filter-bar-shell'
  },
  bodyClass: {
    type: String,
    default: 'filter-bar-body'
  },
  contentClass: {
    type: String,
    default: 'filter-bar-content is-page'
  },
  showRefresh: {
    type: Boolean,
    default: false
  },
  refreshLoading: {
    type: Boolean,
    default: false
  },
  refreshDisabled: {
    type: Boolean,
    default: false
  },
  refreshText: {
    type: String,
    default: '刷新'
  }
})

const emit = defineEmits(['refresh'])

const shellClass = computed(() => props.shellClass)
const bodyClass = computed(() => props.bodyClass)
const contentClass = computed(() => props.contentClass)

const handleRefresh = () => {
  if (props.refreshDisabled || props.refreshLoading) return
  emit('refresh')
}
</script>
